import Brands from '@/enums/Brands';

export const DEFAULT_DEBOUNCE_TIME = 300;
export const DEFAULT_SNACKBAR_DURATION = 2000;
export const DEFAULT_CLIPBOARD_DURATION = 2500;

export const ANONYMOUS_SESSION_ID_KEY = 'anonymousSessionId';

export const MAX_COMMENT_LENGTH = 1000;

export const TAGS = {
	quickOrder: 'quickOrder',
	anonymousCart: 'anonymousCart',
	authCart: 'authCart',
	recalculateAnonymousCart: 'recalculatedAnonymousCart',
	recalculateAuthCart: 'recalculatedAuthCart',
	shippingAddress: 'shippingAddress',
	billingAddress: 'billingAddress',
	anonymousCartShippingMethods: 'anonymousCartShippingMethods',
	authCartShippingMethods: 'authCartShippingMethods',
	wishlist: 'wishlist',
	freightForwarders: 'freightForwarders',
} as const;

export const CONTACTS_US_EMAIL: Readonly<Record<Brands, string>> = {
	MP: 'shopsupportmpob@irco.com',
	OB: 'shopsupportmpob@irco.com',
	MR: 'shopsupportmpob@irco.com',
	ARO: 'arosupport@irco.com',
	'ILC-US': 'customer_service@ilcdover.com',
	'WV-US': 'welch.na@irco.com',
	DT: 'mailbox@dosatronusa.com',
	'ARO-NA': 'arocustomerservice@irco.com',
};

export const CONTACTS_US_URL: Readonly<Record<Brands, string>> = {
	MP: 'https://www.mppumps.com/en-us/modals/contact',
	OB: 'https://www.oberdorferpumps.com/en-us/modals/contact',
	MR: 'https://www.miltonroy.com/en-us/modals/contact',
	ARO: 'https://www.arozone.com/en/contact/',
	'ILC-US': 'https://www.ilcdover.com/en/contact ',
	'WV-US': 'https://welchvacuum.com/en/modals/contact',
	DT: 'https://www.dosatron.com/en-us/modals/contact',
	'ARO-NA': 'https://www.arozone.com/en/contact/',
};

export const RETURNS_CLAIMS_EMAIL: Readonly<Partial<Record<Brands, string>>> = {
	'ARO-NA': 'aroclaims@irco.com',
};

export const TERM_AND_CONDITIONS_URL: Readonly<Record<Brands, { openInNewTab?: boolean; url: string }>> = {
	MP: {
		url: 'https://azure-na-assets.contentstack.com/v3/assets/blt1f85faf7793e4aae/blte1d8b96ad897f1cc/68d2a890ee25f82fb9aea182/MPOB_Terms_and_Conditions_of_Sale_(USA_06.2024).pdf',
	},
	OB: {
		url: 'https://azure-na-assets.contentstack.com/v3/assets/blt1f85faf7793e4aae/blte1d8b96ad897f1cc/68d2a890ee25f82fb9aea182/MPOB_Terms_and_Conditions_of_Sale_(USA_06.2024).pdf',
	},
	MR: {
		url: 'https://www.arozone.com/content/published/api/v1.1/assets/CONTB2C235CDEB624E04986BAC98AA242F6F/native/Terms+and+Conditions+Of+Sale+-+Ingersoll+Rand+Group.pdf?channelToken=830c28dbcb1248fe9d8a689144ba62f7',
	},
	ARO: {
		url: 'https://azure-na-assets.contentstack.com/v3/assets/blt7de7417393caec8b/bltbb53016491a89249/6878e48c4f55313c84466f25/Terms_and_Conditions_Of_Sale_-_Ingersoll_Rand_Group.pdf',
	},
	'ILC-US': {
		openInNewTab: true,
		url: 'https://www.ilcdover.com/en/terms-conditions/',
	},
	'WV-US': {
		url: 'https://azure-na-assets.contentstack.com/v3/assets/blt68345eecc45d4e9d/blt74377376269eec7e/Welch-Webstore-TCs',
	},
	DT: {
		url: 'https://www.dosatron.com/en-nam/terms-conditions/',
	},
	'ARO-NA': {
		openInNewTab: true,
		url: 'https://azure-na-assets.contentstack.com/v3/assets/blta3c1d56420975795/bltd1bc30a3ac28e1fc/680791febce3ec01f41d9903/IRP-En-Brochure-ingersoll-rand-company-standard-terms-and-conditions-of-sale-0317.pdf',
	},
};

export const REQUEST_QUOTE_URL = {
	MP: 'https://www.mppumps.com/en/request-a-quote/',
	OB: 'https://www.oberdorferpumps.com/en/request-a-quote/',
	MR: null,
	ARO: null,
	'ILC-US': 'https://www.ilcdover.com/en/request-a-quote/',
	'WV-US': 'https://www.welchvacuum.com/en-us/request-a-quote/',
	DT: null,
	'ARO-NA': null,
} as const satisfies Record<Brands, string | null>;

export const ABOUT_US_URL: Readonly<Record<Brands, { openInNewTab?: boolean; url: string }>> = {
	MP: {
		url: '',
	},
	OB: {
		url: '',
	},
	MR: {
		url: '',
	},
	ARO: {
		url: '',
	},
	'ILC-US': {
		url: '',
	},
	'WV-US': {
		url: 'https://www.welchvacuum.com/en-us/about-us',
	},
	DT: {
		url: 'https://www.dosatron.com/en-us/about-us',
	},
	'ARO-NA': {
		url: '',
	},
};
export const SEARCH_MAX_LIMIT = 20;

export const HEADER_HEIGHT_MOBILE = 115;
export const HEADER_HEIGHT_TABLET_AND_ABOVE = 131;
export const CHECKOUT_SUMMARY_HEIGHT = 100;
export const YOUTUBE_IMG_BASE_URL = 'https://img.youtube.com';
export const YOUTUBE_EMBED_BASE_URL = 'https://www.youtube.com/embed';
export const ZENDESK_SNIPPET_URL = 'https://static.zdassets.com/ekr/snippet.js';
